import { useLoadBasicData } from '../../../hooks/useLoadBasicData';
import { useMemorizedCacheTags } from '../../../hooks/useMemorizedCacheTag';
import {
  _PeopleQuery,
  LessonItemFragment,
  useLessonsForSchoolYearQuery,
  useListPlannedTeacherTeachingLoadQuery,
} from '../../../types/planung-graphql-client-defs';

const NO_LESSONS: LessonItemFragment[] = [];
const NO_PEOPLE: _PeopleQuery['people'] = [];

export type DeputateLessonsQueryResult = {
  /** Zuordnungen des Schuljahres, vom Backend sortiert (Klassen, Fach, Lehrer). */
  lessons: LessonItemFragment[];
  /** Alle Lehrkräfte – für Dropdowns */
  people: _PeopleQuery['people'];
  deputateByTeachersData: ReturnType<typeof useListPlannedTeacherTeachingLoadQuery>[0]['data'];
  refetchLessons: () => void;
};

export function useDeputateLessonsQuery(
  organizationUuid: string,
  schoolYearUuid: string | undefined,
): DeputateLessonsQueryResult {
  // additionalTypenames müssen auch der Query mitgegeben werden, damit der urql-Cache sie
  // selbst bei leerem Ergebnis (z.B. vor dem ersten Import) als von Lesson/LessonClass abhängig
  // registriert – sonst invalidiert eine Lesson-Mutation diese (leere) Query nicht.
  const context = useMemorizedCacheTags(['LESSONS', 'LESSON_CLASS']);

  const [{ data: lessonsQueryData }, refetchLessons] = useLessonsForSchoolYearQuery({
    variables: { schoolYearUuid: schoolYearUuid ?? '' },
    context,
    pause: !schoolYearUuid,
  });

  const [{ data: deputateByTeachersData }] = useListPlannedTeacherTeachingLoadQuery({
    variables: {
      organizationUuid,
      schoolYearUuid: schoolYearUuid ?? '',
    },
    context,
    pause: !schoolYearUuid,
  });

  const { teacherData } = useLoadBasicData({ pause: false, schoolYearUuid });

  return {
    lessons: lessonsQueryData?.lessonsForSchoolYear ?? NO_LESSONS,
    people: teacherData?.people ?? NO_PEOPLE,
    deputateByTeachersData,
    refetchLessons,
  };
}
